import React, { useState, useEffect } from "react";
import RecentVotes from "./RecentVotes";
import RecentProposals from "./RecentProposals";
import VisibilityButton from "./VisibilityButton";
import RecentUsers from "./RecentUsers";

export default function RecentActivity() {
  const [userVis, setUserVis] = useState(true);
  const [propVis, setPropVis] = useState(true);
  const [voteVis, setVoteVis] = useState(true);

  return (
    <>
      <p>
        <b
          style={{
            fontSize: 24,
            textDecoration: "underline",
            margin: "1em auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          Last 30 Days
        </b>
      </p>

      <br />
      <VisibilityButton
        text={"Proposals"}
        setter={setPropVis}
        state={propVis}
      ></VisibilityButton>
      {propVis ? <RecentProposals /> : null}
      <br />
      <VisibilityButton
        text={"UsersCC"}
        setter={setUserVis}
        state={userVis}
      ></VisibilityButton>
      {userVis ? <RecentUsers /> : null}

      <br />

      <VisibilityButton
        text={"Votes"}
        setter={setVoteVis}
        state={voteVis}
      ></VisibilityButton>
      {voteVis ? <RecentVotes /> : null}
    </>
  );
}
